/**
 * Plugin to allow accessibility inside a modale and stay inside the modale.
 */
(function ($) {

    $.fn.modalAccessTabbing = function () {

        var tabbing = function (jqSelector) {
            var inputs = getInputs(jqSelector);

            inputs.first().addClass('input-first');
            inputs.last().addClass('input-last');

            //Focus to first element in the container.
            inputs.first().focus();

            $(jqSelector).on('keydown', function (e) {
                if (e.which === 9) {

                    var inputs = getInputs(jqSelector);

                    /*redirect last tab to first input*/
                    if (!e.shiftKey) {
                        if (inputs[inputs.length - 1] === e.target) {
                            e.preventDefault();
                            inputs.first().focus();
                        }

                        if ($(document.activeElement).hasClass('input-last')) {
                            e.preventDefault();
                            $('.input-first').focus();
                        }
                    }
                    /*redirect first shift+tab to last input*/
                    else {
                        if (inputs[0] === e.target) {
                            e.preventDefault();
                            inputs.last().focus();
                        }
                    }
                }
            });
        };

        var getInputs = function (jqSelector) {
            return $(jqSelector).find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex]').not(':disabled').not(':hidden');
        };

        return this.each(function () {
            tabbing(this);
        });

    };
})(jQuery);